import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/event/invitationLetter';
const eventTypeUrl = base_url+'api/admin/prEventType';
const countriesUrl = base_url+'api/admin/esCountries';
const programManagerUrl = base_url+'api/event/programManager';
const receiptIdUrl = base_url+'api/event/receiptIdGeneration';
const seriesTypeUrl = base_url+'api/admin/esSeriesSetup';
const conferenceEventUrl = base_url+'api/admin/conferenceEvent';
const webinarEventUrl = base_url+'api/admin/webinarEvent';
const invitationCategoryTypeUrl = base_url+'api/admin/invitationCategory';


export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};
export const getprogramManager = async (params) => {
    const whereParam = params;
    const response = await api.post(programManagerUrl, whereParam);
    return response.data.data;
};

export const getseriesType = async (params) => {
    const whereParam = params;
    const response = await api.post(seriesTypeUrl, whereParam);
    return response.data.data;
};

export const getconferenceEvent = async (params) => {
  const whereParam = params;
  const response = await api.post(conferenceEventUrl, whereParam);
  return response.data.data;
};

export const getwebinarEvent = async (params) => {
  const whereParam = params;
  const response = await api.post(webinarEventUrl, whereParam);
  return response.data.data;
};

export const getinvitationCategory = async () => {
    const response = await api.get(invitationCategoryTypeUrl);
    return response.data.data;
};

export const getReceiptId = async (params) => {
    try {
      const response = await api.post(receiptIdUrl, params);  // Pass params directly
      return response.data.data;
    } catch (error) {
      console.error("Error fetching receipt ID:", error);
      throw error;
    }
};

export const getDataById = async (data) => {
    const response = await api.post(path, data);
    return response.data;
};
  
export const getcountries = async () => {
    const response = await api.get(countriesUrl);
    return response.data.data;
};

export const geteventType = async () => {
    const response = await api.get(eventTypeUrl);
    return response.data.data;
};

export const addData = async (data) => {
    const response = await api.post(path, data);
    return response.data;
};

export const updateData = async (data) => {
    const response = await api.put(path, data);
    return response.data;
};

export const deleteData = async (data) => {
    const response = await api.delete(path, {
      data: { id: data.id },
    });
    return response.data;
};